import React from "react";


export const lectureSliderSettings = {
  dots: false,
  infinite: false,
  autoplay:false,
  slidesToShow: 6.2,
  slidesToScroll: 2,
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,
  responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 5.1 } },
    { breakpoint: 1600, settings: { slidesToShow: 4.3 } },
    { breakpoint: 1400, settings: { slidesToShow: 3.9 } },
    { breakpoint: 1200, settings: { slidesToShow: 3.9 } },
    { breakpoint: 991, settings: { slidesToShow: 2.7 } },
    { breakpoint: 767, settings: { slidesToShow: 2.2 } },
    { breakpoint: 576, settings: { slidesToShow:1.9 } },
    { breakpoint: 400, settings: { slidesToShow: 1.3 } },
  ],
};


const LectureCard = ({ item }) => {
  return (
    <div className="lecture-card ">
    <h6 className="lecture-title blackText fw-bold">{item.title}</h6>
      {/* Image */}
      <div className="lecture-img">
        <img src={item.image} alt={item.title} />

        {/* Category Tag */}
        <span className="lecture-tag fw-medium">{item.category}</span>
      </div>

      {/* Content */}
      <div className="lecture-body">
        <p className="lecture-desc fw-normal grayText">
            {item.description}
        </p>

        <p className="lecture-time fw-medium font11 blackText mb-0">
          <span>Time Duration:</span> {item.time}
        </p>
      </div>
    </div>
  );
};

export default LectureCard ;
